/* bristm-why — section script (loaded only where the section renders) */
(function () {
  if (window.BRISTM_WHY) return;
  window.BRISTM_WHY = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stages = [];
  var visible = new Set();
  var ticking = false;

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) visible.add(entry.target);
              else visible.delete(entry.target);
            });
            request();
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function update() {
    ticking = false;
    if (reduce.matches) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var mobile = window.innerWidth < 768;
    visible.forEach(function (section) {
      if (!section.isConnected) {
        visible.delete(section);
        return;
      }
      section.querySelectorAll('[data-b-why-photo]').forEach(function (photo) {
        var frame = photo.firstElementChild;
        if (!frame) return;
        var r = photo.getBoundingClientRect();
        /* -1 when the photo sits below the viewport, 0 when centred, 1 above */
        var p = (vh / 2 - (r.top + r.height / 2)) / (vh / 2 + r.height / 2);
        p = Math.max(-1.2, Math.min(1.2, p));
        var speed = parseFloat(photo.getAttribute('data-speed')) || 0.2;
        var spin = parseFloat(photo.getAttribute('data-spin')) || 0;
        var base = parseFloat(photo.getAttribute('data-rotate')) || 0;
        var travel = (mobile ? 0.35 : 1) * speed * Math.min(vh, 1100);
        frame.style.setProperty('--b-why-y', (-p * travel).toFixed(1) + 'px');
        frame.style.setProperty('--b-why-r', (base + p * spin * (mobile ? 0.5 : 1)).toFixed(2) + 'deg');
      });
    });
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-why]').forEach(function (section) {
      if (section.dataset.bBound) return;
      section.dataset.bBound = '1';
      stages.push(section);
      if (observer) observer.observe(section);
      else visible.add(section);
    });
    request();
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
